import axios from "axios";
import config from "../config/config";
import { DevicePlatformType, UserPlatform } from "../common/types/common.types";

const baseUri = config.api.baseURL;
// const outBoundLocalService="http://localhost:3081"

export const urls = {
  User_URI: `${baseUri}/auth/api/v1`,
  Ticket_URI: `${baseUri}/ticket/api/v1`,
  //Ticket_URI: ` http://localhost:3009/ticket/api/v1`,
  OZONETEL_URI: `${baseUri}/ozonetel/api/v1`,
  BENEFICIARY_URI: `${baseUri}/beneficiary/api/v1`,
  Hospital_URI: `${baseUri}/hospital/api/v1`,
  //Hospital_URI: "http://localhost:3005/hospital/api/v1",
  Whatsapp_URI: `${baseUri}/whatsapp/api/v1`,
  AZURE_URI: `${baseUri}/azure/api/v1`,
  SSE_URI: `${baseUri}/ticket/api/v1`,
  CALL_URI: `${baseUri}/call/api/v1`,
  // OUTBOUNDCALL_URI: `${outBoundLocalService}/api/v1`,
  Company_URI: `${baseUri}/company/api/v1`,
  VIDEO_URL: `${baseUri}/video/api/v1`,
  //VIDEO_URL: `http://localhost:3005/video/api/v1`,
  PAYMENT_URL: `${baseUri}/payment/api/v1`,


};
const axiosInstance = axios.create({
  baseURL: "",
  withCredentials: true,
  headers: {
    "content-type": "application/json",
    Accept: "application/json",
  },
});

/// auth-user-service
export const agentLogin = (payload: any) =>
  axiosInstance.post(`${urls.User_URI}/auth/poco-user-login`, payload);

export const verifyToken = async () =>
  await axiosInstance.post(`${urls.User_URI}/auth/verify-token`);

export const agentPwdReset = (payload: any, id: string) =>
  axiosInstance.patch(`${urls.User_URI}/pocousers/reset-pwd/${id}`, payload);

export const agentPwdUpdate = (payload: any) => axiosInstance.post(`${urls.User_URI}/auth/poco-user-verify-forgot-pwd-secret`, payload);

export const forgotPwdVerifyEmail = (payload: any) => axiosInstance.post(`${urls.User_URI}/auth/poco-user-forgot-pwd`, payload)

export const forgotPwdVerifySecret = (payload: any) => axiosInstance.post(`${urls.User_URI}/pocousers/poco-user-verify-forgot-pwd-secret`, payload)

export const adminUserLogout = () => axiosInstance.get(`${urls.User_URI}/auth/poco-admin-user-logout`);

export const upsertFcmToken = async (payload: {
  token: string;
  platform: UserPlatform
  platformType: DevicePlatformType;
  deviceId?: string;
}) => axiosInstance.post(`${urls.User_URI}/fcm-tokens/upsert`, payload);

export const verifyAdminToken = async () =>
  axiosInstance.post(`${urls.User_URI}/auth/verify-admin-token`);

export const getDoctorById = (id: string) =>
  axiosInstance.get(`${urls.User_URI}/doctor/${id}`);

export const getAllDoctors = () =>
  axiosInstance.get(`${urls.User_URI}/doctor`);
///ticket-service

export const getAllTicket = (url: string) =>
  axiosInstance.get(`${urls.Ticket_URI}/ticket/get-ticket-by-filter?${url}`);

export const getTicketById = (ticketId: string) =>
  axiosInstance.get(`${urls.Ticket_URI}/ticket/${ticketId}`);

export const ticketUpdateById = (ticketId: string, payload: any) =>
  axiosInstance.patch(`${urls.Ticket_URI}/ticket/${ticketId}`, payload);

export const uploadCaseStudy = (file: File, ticketId: string) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("ticketId", ticketId);

  return axiosInstance.post(
    `${urls.Ticket_URI}/case-study/upload`,
    //`http://localhost:3009/ticket/api/v1/case-study/upload`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

export const handleEmergencyPopupClose = (id: string) =>
  axiosInstance.get(`${urls.SSE_URI}/emergency-handled/${id}`);

export const getPocoTeamData = () => axiosInstance.get(`${urls.Ticket_URI}/ticket-configurations`);

export const createAmbulance = (payload: any) =>
  axiosInstance.post(`${urls.Ticket_URI}/ambulance`, payload);

export const updateAmbulanceData = (id: string, payload: any) =>
  axiosInstance.patch(`${urls.Ticket_URI}/ambulance/update-by-ticket-id/${id}`, payload);

export const createExtendedTrip = (payload: any) =>
  axiosInstance.post(`${urls.Ticket_URI}/ambulance/extended-trip`, payload);

export const deleteDropLocation = (ticketId: string, index: number) =>
  axiosInstance.delete(`${urls.Ticket_URI}/ambulance/drop-location/${ticketId}/${index}`);

export const addDeltaCharges = (payload: any) =>
  axiosInstance.post(`${urls.Ticket_URI}/ambulance/delta-charges`, payload);

export const calculateFareApi = (payload: { provider: string; documentId: string }) => axiosInstance.post(`${urls.Ticket_URI}/ambulance/calculate-fare`, payload);

export const fetchAmbulanceById = (id: string) =>
  axiosInstance.get(`${urls.Ticket_URI}/ambulance/find-by-query?ticket_id=${id}`);

export const submitAmbulanceCancellationReason = (ticketId: string, payload: { reason: string; isChargeable: boolean }) =>
  axiosInstance.post(`${urls.Ticket_URI}/ambulance/cancellation-reason/${ticketId}`, payload);
export const addDeltaCharge = (payload: any) =>
  axiosInstance.post(`${urls.Ticket_URI}/ambulance/delta-charges`, payload);

///beneficiary-service

export const getAllBeneficiaryBySubId = (subId: string) =>
  axiosInstance.get(
    `${urls.BENEFICIARY_URI}/beneficiary/find-by-subscriber-id/${subId}`
  );

export const getAllBeneficiaryBySubIdIncludeDeleted = (subId: string) =>
  axiosInstance.get(
    `${urls.BENEFICIARY_URI}/beneficiary/find-by-subscriber-id-include-deleted/${subId}`
  );

export const getSingleBenData = (benId: string) =>
  axiosInstance.get(`${urls.BENEFICIARY_URI}/beneficiary/find-by-id/${benId}`);

export const getSingleBenDataIncludeDeleted = (benId: string) =>
  axiosInstance.get(`${urls.BENEFICIARY_URI}/beneficiary/find-by-id-include-deleted/${benId}`);

export const getBenByMobile = (mobile: string) =>
  axiosInstance.get(
    `${urls.BENEFICIARY_URI}/beneficiary/find-by-mobile-number-or-wp-number/${mobile}`
  );

export const getProfilePerk = (benId: string) =>
  axiosInstance.get(
    `${urls.BENEFICIARY_URI}/beneficiary/medical-info-perk/${benId}`
  );

export const getMedicalInfo = (benId: string) =>
  axiosInstance.get(
    `${urls.BENEFICIARY_URI}/beneficiary/medical-info-record/${benId}`
  );
export const getBenByCompanyName = (payload: any) =>
  axiosInstance.post(
    `${urls.BENEFICIARY_URI}/beneficiary/search-by-ben-or-company`,
    payload
  );

export const getSubById = (id: string) =>
  axiosInstance.get(
    `${urls.BENEFICIARY_URI}/subscriber/${id}`
  );

//hospital-service - unified query API
export const queryHospitals = (payload: any, controller?: AbortController) => {
  return axiosInstance.post(
    `${urls.Hospital_URI}/hospital/query`,
    payload,
    controller ? { signal: controller.signal } : {}
  );
}

export const getAllHospitals = () =>
  axiosInstance.get(`${urls.Hospital_URI}/hospital`);
export const getAllHospitalById = (id: string) =>
  axiosInstance.get(`${urls.Hospital_URI}/hospital/${id}`);
export const roadDistanceAndTime = (payload: any) => axiosInstance.post(`${urls.AZURE_URI}/google-map/get-time-distance`, payload);
export const getDoctorsRoster = (day: string) => { return axiosInstance.get(`${urls.Hospital_URI}/doctor-rosters/get-slots/${day}`) }
export const getPocoDoctors = () => axiosInstance.get(`${urls.Hospital_URI}/poco-doctors`);

/// Ambulance Provider
export const ambulanceProvidersQueryApi = (payload: Object) => axiosInstance.post(`${urls.Hospital_URI}/ambulance-provider/search`, payload)

export const ambulanceRatecardsQueryApi = (payload: Object) => axiosInstance.post(`${urls.Hospital_URI}/ambulance-rate-card/search`, payload);


// Poco-Ambulance-rate-card
export const fetchAllPocoRateCard = () => axiosInstance.get(`${urls.Hospital_URI}/poco-ambulance-rate-card`);

// Company Rate Cards
export const getCompanyRateCards = (companyId: string) => axiosInstance.get(`${urls.Hospital_URI}/company-rate-card-mapping/company/${companyId}/rate-cards`);

export const getCompanyRateCardsByPlan = (companyId: string, planId: string) => axiosInstance.get(`${urls.Hospital_URI}/company-rate-card-mapping/company/${companyId}/plan/${planId}/rate-cards`);
// Poco-Fare-calculation
export const fareCalculationApi = (payload: Object) => axiosInstance.post(`${urls.Hospital_URI}/ambulance-rate-card/calculate-fare`, payload);
export const getExtraChargesApi = (rateCardName: string) => axiosInstance.get(`${urls.Hospital_URI}/poco-ambulance-rate-card/extra-charges/${rateCardName}`);

//  Doctor services
export const doctorRatecardsQueryApi = () => axiosInstance.get(`${urls.Hospital_URI}/doctor-rate-card`);


// video-service
export const sendMeetingLink = (payload: string) => axiosInstance.post(`${urls.VIDEO_URL}/video-service/create-room`, payload)
export const createConsultation = (payload: { ticket_id: number | string; consultation_mode: "audio" | "video"; doctor_ids?: string[] }) =>
  axiosInstance.post(`${urls.VIDEO_URL}/consultation`, payload)
export const redispatchConsultation = (consultationId: string, doctorIds: string[]) =>
  axiosInstance.patch(`${urls.VIDEO_URL}/consultation/${consultationId}/redispatch`, { doctor_ids: doctorIds })
export const consultationStatusSse = (consultationId: string) =>
  `${urls.VIDEO_URL}/consultation/${consultationId}/status/stream`
export const getConsultationById = (consultationId: string) =>
  axiosInstance.get(`${urls.VIDEO_URL}/consultation/${consultationId}`)

export const createSseConnection = (
  url: string,
  headers: Record<string, string>,
  onMessage: (data: string) => void,
  onError?: (err: any) => void
): { close: () => void } => {
  const controller = new AbortController();

  fetch(url, {
    credentials: "include",
    headers: { ...headers, Accept: "text/event-stream" },
    signal: controller.signal,
  })
    .then((res) => {
      console.log("[SSE] connection established, status:", res.status);
      const reader = res.body?.getReader();
      const decoder = new TextDecoder();
      const read = () => {
        reader?.read().then(({ done, value }) => {
          if (done) {
            console.log("[SSE] stream done/closed by server");
            return;
          }
          const chunk = decoder.decode(value, { stream: true });
          console.log("[SSE] raw chunk:", JSON.stringify(chunk));
          chunk.split("\n").forEach((line) => {
            console.log("[SSE] line:", JSON.stringify(line));
            if (line.startsWith("data:")) {
              const payload = line.slice(5).trim();
              console.log("[SSE] dispatching payload:", payload);
              onMessage(payload);
            }
          });
          read();
        }).catch((err) => {
          if (err?.name !== "AbortError") onError?.(err);
        });
      };
      read();
    })
    .catch((err) => {
      if (err?.name !== "AbortError") onError?.(err);
    });

  return { close: () => controller.abort() };
}

///whatsapp-service
export const sendWhatsAppMessage = (payload: any) =>
  axiosInstance.post(`${urls.Whatsapp_URI}/whatsapp`, payload);
//azure-service
export const getAzureSignedUrl = (
  docName: string,
  benId: string,
  docType: string
) =>
  axiosInstance.post(`${urls.AZURE_URI}/signedUrl/generateSignedUrl`, {
    docName,
    benId,
    docType,
  });
// export const generateSasToken = () => {
//     return axiosInstance.get(`${urls.AZURE_URI}/signedUrl/regenerateSaSToken`, {
//     })
//  };

export const addressAutoComplete = (locationText: any) => {
  return axiosInstance.get(`${urls.AZURE_URI}/google-map/autocomplete?input=${locationText}`);
}

export const distanceMatrix = (payload: any) => {
  return axiosInstance.post(`${urls.AZURE_URI}/google-map/getdistance`, payload);
}

export const getLatLon = (payload: any) => {
  return axiosInstance.post(`${urls.AZURE_URI}/google-map/getgeocode`, payload);
}

export const addressFromPlacid = (placeId: string) => {
  return axiosInstance.get(`${urls.AZURE_URI}/google-map/getfulladdress?placeId=${placeId}`);
}

export const calculateDistance = ({ originLat, originLng, destLat, destLng }: any) => {
  return axiosInstance.get(`${urls.AZURE_URI}/google-map/calculate-distance?originLat=${originLat}&originLng=${originLng}&destLat=${destLat}&destLng=${destLng}`);
}

export const uploadFileHttp = (payload: any) => axiosInstance.post(`${urls.AZURE_URI}/signedUrl/uploads`, payload, {
  headers: {
    "Content-Type": "multipart/form-data",
  },
})


//sse
export const sseRegister = `${urls.SSE_URI}/register`;
//paymentNotifySSe
export const paymentNotifySse = `${urls.PAYMENT_URL}/sse/events`

///ozonetel-service
export const callManually = (payload: any) =>
  axiosInstance.post(`${urls.CALL_URI}/call/clicktocall`, payload);

export const callAmbulanceManually = (payload: any) =>
  axiosInstance.post(`${urls.CALL_URI}/call/clicktocall-ambulance`, payload);

export const callBtwDP = (payload: any) =>
  axiosInstance.post(`${urls.CALL_URI}/call/clicktocallBtwDP`, payload);

//companyService
export const getOfficeDataById = (campusId: string) =>
  axiosInstance.get(`${urls.Company_URI}/company-service/offices/${campusId}`);
export const getAllOffices = () =>
  axiosInstance.get(`${urls.Company_URI}/company-service/partnerCompanies`);
export const getCompanyByID = (companyId: string) =>
  axiosInstance.get(`${urls.Company_URI}/company-service/partnerCompanies/find-company-by-id/${companyId}`);

///call-service
export const getAllCallLogsByTicketId = (ticketId: string) =>
  axiosInstance.get(`${urls.CALL_URI}/call/get-call-log/${ticketId}`);

export const saveCallDetailsLogs = (payload: any) =>
  axiosInstance.post(`${urls.CALL_URI}/call/save-log`, payload);

export const outBoundCallList = (url: string) =>
  axiosInstance.get(

    `${urls.CALL_URI}/outbound-handle/get-outboundcal-by-filter?${url}`
  );
export const updateAgentNotesToCall = (
  id: string,
  payload: { ucid: string; agentNotes: string }
) => axiosInstance.patch(`${urls.CALL_URI}/outbound-handle/${id}`, payload);

export const getTataAgents = () =>
  axiosInstance.get(`${urls.CALL_URI}/tata-telecom-service/agents`);

export const callMergeApi = (payload: { agent_id: string; call_id: string }) =>
  axiosInstance.post(`${urls.CALL_URI}/tata-telecom-service/call-merge`, payload);

//payment_apis_razorPay
export const sendPaymentLink = (payload: any) => axiosInstance.post(`${urls.PAYMENT_URL}/order/paymentLink`, payload);
export const resendPaymentLink = (paymentLinkId: string) => axiosInstance.get(`${urls.PAYMENT_URL}/order/resendLinkSms/${paymentLinkId}`);

//paymentApi_local_DB_Order
export const getOrdersByTicketId = (ticketId: string) => axiosInstance.get(`${urls.PAYMENT_URL}/order/getOrder/${ticketId}`);
export const refreshPaymentStatus = (ticketId: string) => axiosInstance.get(`${urls.PAYMENT_URL}/order/refresh-status/${ticketId}`);

export const getCoveredCities = () => {
  return axiosInstance.get(`${urls.Hospital_URI}/ambulance-city`);
}

export const getNearbyAmbulanceProviders = (payload: { latitude: number; longitude: number }) =>
  axiosInstance.post(`${urls.Hospital_URI}/ambulance-provider/nearby`, payload);

export const getLiveCallStatus = () =>
  axiosInstance.get(`${urls.Ticket_URI}/ticket/live-call-status`);

// Authentication .
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    console.log(
      originalRequest,
      "originalRequest ****************************"
    );
    // console.log(error,'***********');
    // Handle unauthorized errors (status 401)
    if (
      error.response &&
      error.response.status === 401 &&
      originalRequest &&
      !originalRequest._isRetry
    ) {
      originalRequest._isRetry = true;
      try {
        await axios.post(
          `${urls.User_URI}/auth/poco-user-refresh-token`,
          {},
          {
            withCredentials: true, // Ensure credentials are sent with the refresh token request
          }
        );
        // Retry the original request
        return axiosInstance(originalRequest);
      } catch (err) {
        // Handle errors that occur during the refresh token request
        // console.log('err:', err);
        // localStorage.setItem("isLogin", "false");
        // window.location.reload();
        window.location.href = "/login";

      }
      // localStorage.setItem("isLogin", "false");
      // window.location.reload();
      window.location.href = "/login";
    }
    throw error;
  }
);

export default axiosInstance;
